import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => {
  return {
    tabs: {
      maxWidth: '960px',
      height: '52px',
      margin: '0 auto',
      borderBottom: `1px solid ${colorSet.gray300}`,
      '& .MuiTab-textColorInherit:hover': {
        opacity: 1,
        '& p': {
          fontWeight: 700
        }
      },
      '& .Mui-selected span p': {
        fontWeight: 700
      },
      '& .MuiTabs-indicator': {
        display: 'none'
      },
      '& button': {
        padding: 16
      },
      [theme.breakpoints.down(960)]: {
        width: '100%',
        '& .MuiTabs-fixed': {
          overflow: 'scroll !important'
        }
      }
    },
    box: {
      padding: '40px 0',
      width: '100%'
    },
    contents: {
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
      width: '960px',
      margin: '48px auto',
      '& .term': {
        display: 'flex',
        flexDirection: 'column',
        width: '624px',
        gap: '24px',
        '& b': {
          fontSize: 16
        },
        '& h1': {
          fontSize: 20
        },
        '& i': {
          fontStyle: 'italic'
        },
        '& pre': {
          fontSize: '12px',
          lineHeight: '18px',
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word'
        },
        [theme.breakpoints.down(960)]: {
          width: 'auto',
          minWidth: '375px'
        }
      },
      '& .desktopList': {
        width: '296px',
        height: 'auto',
        borderRadius: '12px',
        border: `1px solid ${colorSet.gray400}`,
        margin: '56px 0 auto 0',
        paddingBottom: '16px',
        '& p': {
          padding: '16px'
        },
        '& .item': {
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: colorSet.gray100
          }
        },
        '& .selectedItem': {
          cursor: 'pointer',
          backgroundColor: colorSet.gray100
        },
        [theme.breakpoints.down(960)]: {
          display: 'none'
        }
      },
      '& .mobileList': {
        width: '100%',
        marginBottom: '36px',
        '& .dropDown': {
          width: '100%',
          height: '48px',
          padding: '12px',
          border: `1px solid ${colorSet.gray400}`,
          borderRadius: '8px',
          justifyContent: 'space-between'
        },
        [theme.breakpoints.up(960)]: {
          display: 'none'
        }
      },
      [theme.breakpoints.down(960)]: {
        width: '100vw',
        minWidht: '375px',
        flexDirection: 'column',
        margin: '0',
        padding: '16px'
      }
    }
  };
});
